import { render, staticRenderFns } from "./schedule-add-or-update.vue?vue&type=template&id=1f0c2c82&"
import script from "./schedule-add-or-update.vue?vue&type=script&lang=js&"
export * from "./schedule-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports